import { useAppContext } from '@contexts/app';
import { useEffect } from 'react';
import { useTrackingCode } from 'react-hubspot-tracking-code-hook';
import { useLocation } from 'react-router';

export const useHubspot = () => {
  const { setPathPageView, setTrackPageView, setIdentity } = useTrackingCode();
  const { pathname } = useLocation();
  const { email } = useAppContext();

  useEffect(() => {
    setPathPageView(pathname);
    setTrackPageView();
  }, [setPathPageView, setTrackPageView, pathname]);

  useEffect(() => {
    setIdentity(email);
  }, [setIdentity, email]);
};
